import React from 'react';
import { bool, shape, string } from 'prop-types';

const Speed = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8385 4.78653L13.761 3.39903L13.7685 3.39153C14.5204 4.55127 14.9373 5.89625 14.9731 7.27799C15.0088 8.65973 14.662 10.0245 13.971 11.2215C13.8388 11.4504 13.6485 11.6404 13.4193 11.7721C13.1902 11.9038 12.9303 11.9726 12.666 11.9715H2.27846C2.01669 11.9699 1.75989 11.8999 1.53358 11.7683C1.30728 11.6367 1.11934 11.4482 0.988459 11.2215C0.155772 9.76457 -0.164236 8.07045 0.0796223 6.41014C0.323481 4.74983 1.11712 3.21927 2.33358 2.06329C3.55004 0.907299 5.11905 0.192677 6.78963 0.0337287C8.4602 -0.12522 10.1358 0.280689 11.5485 1.18653L10.161 2.10903C9.00746 1.532 7.69872 1.34204 6.42876 1.5673C5.15881 1.79256 3.99525 2.42105 3.11057 3.3596C2.22589 4.29815 1.6672 5.49679 1.51731 6.77783C1.36743 8.05887 1.63434 9.3541 2.27846 10.4715H12.6735C13.1691 9.61152 13.4436 8.64199 13.4723 7.64982C13.5011 6.65765 13.2833 5.67383 12.8385 4.78653Z" fill="currentColor" />
    <path d="M6.9053 8.85462C6.7232 8.77913 6.55777 8.66849 6.41846 8.52903C6.279 8.38972 6.16836 8.22428 6.09287 8.04219C6.01739 7.86009 5.97853 7.6649 5.97853 7.46778C5.97853 7.27065 6.01739 7.07546 6.09287 6.89336C6.16836 6.71127 6.279 6.54584 6.41846 6.40653L12.786 2.16153L8.54096 8.52903C8.40165 8.66849 8.23622 8.77913 8.05412 8.85462C7.87203 8.9301 7.67683 8.96896 7.47971 8.96896C7.28259 8.96896 7.0874 8.9301 6.9053 8.85462Z" fill="currentColor" />
  </svg>
);

Speed.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Speed;
